import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getIncomingProviderPatientRequests,
  respondProviderPatientRequest,
} from "../api/providerPatientRequests.api";

export function useProviderPatientRequests(options: {
  enabled: boolean;
  keyScope?: string;
}) {
  const queryClient = useQueryClient();
  const keyScope = options.keyScope || "self";

  const query = useQuery({
    queryKey: ["provider-patient-requests", "incoming", keyScope],
    queryFn: () => getIncomingProviderPatientRequests(),
    enabled: options.enabled,
  });

  const respond = useMutation({
    mutationFn: async ({
      id,
      action,
      makePrimary,
    }: {
      id: string;
      action: "accept" | "decline";
      makePrimary?: boolean;
    }) => respondProviderPatientRequest(id, action, makePrimary ?? false),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["provider-patient-requests", "incoming", keyScope],
      });
      await queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });

  return { query, respond };
}
